import { Component } from "react"
import PropTypes from "prop-types"

import loadHeroImage from "shared/lib/load_hero_image"
import { partialStoryShape } from "app/lib/shared_prop_types"

class StoryCard extends Component {
  render() {
    const giveItTheBusiness = this.props.story.category === "Business" ? "/business" : ""
    const heroImage = loadHeroImage(this.props.story.hero_image, "rectangular")

    return (
      <a
        className="story-box"
        title={this.props.story.title}
        aria-label={this.props.story.title}
        style={{
          background: `linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0,0,0,0) 75%, rgba(0, 0, 0, 0.2)), url(${heroImage})`,
          backgroundPosition: "center bottom",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundColor: `${this.props.story.hero_image["background_color"]}`,
        }}
        ref={el => {
          this.scrollObserverEl = el
        }}
        href={`/${this.props.singleStoryBasePath}${giveItTheBusiness}/${this.props.story.slug}`}
      >
        <div className="title">
          <h2>{this.props.story.title}</h2>
        </div>
      </a>
    )
  }
}

StoryCard.propTypes = {
  story: partialStoryShape.isRequired,
  position: PropTypes.number.isRequired,
  singleStoryBasePath: PropTypes.string.isRequired,
}

export default StoryCard
